import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-learn-sticky-player',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './parent-learn-sticky-player.component.html',
  styleUrl: './parent-learn-sticky-player.component.scss',
})
export class ParentLearnStickyPlayerComponent {
  lessonTitle = input('');
  expand = output<void>();
}
